import script from "./HeaderBox.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderBox.vue?vue&type=script&setup=true&lang=js"

import "./HeaderBox.vue?vue&type=style&index=0&id=25d879f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25d879f8"]])

export default __exports__